"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertValueToStringArray = exports.CallDetailKeyValueTile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const toolbox_1 = require("@streem/toolbox");
const analytics_1 = require("@streem/analytics");
const CallDetailKeyValueTile = ({ title, keyValuePairs, maxValuesToDisplay = 2, columnsPerRow, dataIdPrefix, keyValueStyles, keyValueTitleStyles = {}, keyValueTileStyles = {}, isTrayOpen, }) => {
    var _a, _b, _c;
    const tileBottomPadding = (_a = keyValueTileStyles.bottomPadding) !== null && _a !== void 0 ? _a : '0.5rem';
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(Tile, Object.assign({ bottomPadding: tileBottomPadding }, { children: [title && ((0, jsx_runtime_1.jsx)(Title, Object.assign({ fontSize: (_b = keyValueTitleStyles.fontSize) !== null && _b !== void 0 ? _b : keyValueStyles.fontSize, titleOnly: keyValuePairs.length === 0, "data-testid": (0, toolbox_1.scrubDataId)(`${dataIdPrefix}-tile-title-${title}`), marginBottom: (_c = keyValueTitleStyles.marginBottom) !== null && _c !== void 0 ? _c : '1rem' }, { children: title }))), (0, jsx_runtime_1.jsx)(KeyValues, Object.assign({ title: title !== null && title !== void 0 ? title : undefined, columnsPerRow: columnsPerRow }, { children: keyValuePairs.map(({ key, value, isCopyableYn }, idx) => {
                        return ((0, jsx_runtime_1.jsx)(KeyValue, { k: key, v: value, maxValuesToDisplay: maxValuesToDisplay, fontSize: keyValueStyles.fontSize, dataIdPrefix: (0, toolbox_1.scrubDataId)(`${dataIdPrefix}-${title !== null && title !== void 0 ? title : ''}-${key}-${idx}`), analyticsId: (0, toolbox_1.scrubDataId)(`${dataIdPrefix}-${key}`), isTrayOpen: isTrayOpen, capabilities: { isCopyableYn: isCopyableYn } }, `${dataIdPrefix}-${idx}-key`));
                    }) }))] })) }));
};
exports.CallDetailKeyValueTile = CallDetailKeyValueTile;
const convertValueToStringArray = (value) => {
    if (typeof value === 'string') {
        return [value];
    }
    return value;
};
exports.convertValueToStringArray = convertValueToStringArray;
const KeyValue = ({ k, v, widthPercentage, maxValuesToDisplay, fontSize, dataIdPrefix, capabilities, analyticsId, isTrayOpen, }) => {
    const valueAsArray = (0, exports.convertValueToStringArray)(v);
    const displayValues = valueAsArray.slice(0, maxValuesToDisplay);
    const remainingValueCount = valueAsArray.length - displayValues.length;
    let otherValues = '';
    if (remainingValueCount > 1) {
        otherValues = ` + ${remainingValueCount} others`;
    }
    else if (remainingValueCount === 1) {
        otherValues = ` + ${remainingValueCount} other`;
    }
    const keyStyles = widthPercentage ? { width: `${widthPercentage}%` } : {};
    const canCopyElementToClipboard = capabilities.isCopyableYn;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: keyStyles }, { children: [(0, jsx_runtime_1.jsx)(KeyRow, Object.assign({ fontSize: fontSize, "data-testid": `${dataIdPrefix}-key` }, { children: k })), displayValues.map((displayValue, idx) => {
                const isLastValue = idx === displayValues.length - 1;
                return canCopyElementToClipboard ? ((0, jsx_runtime_1.jsx)(CopyableValue, { dataIdPrefix: dataIdPrefix, displayValue: displayValue, idx: idx, fontSize: fontSize, isLastValue: isLastValue, otherValues: otherValues, analyticsId: analyticsId, isTrayOpen: isTrayOpen }, `${dataIdPrefix}-${displayValue}-${idx}`)) : ((0, jsx_runtime_1.jsx)(ValueRow, Object.assign({ fontSize: fontSize, "data-testid": (0, toolbox_1.scrubDataId)(`${dataIdPrefix}-value-${idx}`) }, { children: `${displayValue}${isLastValue ? otherValues : ''}` }), `${dataIdPrefix}-${displayValue}-${idx}`));
            })] })));
};
const CopyableValue = ({ dataIdPrefix, displayValue, idx, fontSize, isLastValue, otherValues, isTrayOpen, analyticsId, }) => {
    const { addNotification, snackbarNotifications, scheduleNotificationForRemoval } = (0, ui_react_1.useSnackbar)();
    const handleAdd = () => {
        (0, analytics_1.recordElementClicked)(`${analyticsId}-copy-button`);
        navigator.clipboard.writeText(displayValue);
        addNotification({
            id: displayValue,
            message: 'Copied To Clipboard',
            icon: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { color: ui_react_1.Theme.colors.green50, name: "DoneIcon" }),
        });
        scheduleNotificationForRemoval(displayValue, 3000);
    };
    return ((0, jsx_runtime_1.jsxs)(ValueRow, Object.assign({ fontSize: fontSize }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ "data-testid": (0, toolbox_1.scrubDataId)(`${dataIdPrefix}-value-${idx}`) }, { children: `${displayValue}${isLastValue ? otherValues : ''}` })), (0, jsx_runtime_1.jsx)(CopyToClipboardButton, { handleAdd: handleAdd }), (0, jsx_runtime_1.jsx)(ui_react_1.Snackbar, { content: snackbarNotifications, position: { vertical: 'top', horizontal: 'center' }, isTrayOpen: isTrayOpen })] }), `${dataIdPrefix}-${displayValue}-${idx}`));
};
const CopyToClipboardButton = ({ handleAdd }) => {
    return ((0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { iconName: "CopyIcon", label: "Copy Plan Number", background: "grey01A50", size: "medium", onClick: handleAdd }));
};
const Tile = (0, ui_react_1.styled)(ui_react_1.Column)(({ theme, bottomPadding }) => ({
    backgroundColor: theme.colors.grey01A50,
    borderRadius: '0.5rem',
    flexGrow: 1,
    padding: `0.5rem 1rem ${bottomPadding} 1rem`,
}));
const KeyValues = (0, ui_react_1.styled)(ui_react_1.Grid)(props => ({
    gridTemplateColumns: `repeat(${props.columnsPerRow}, 1fr)`,
    columnGap: '1rem',
    rowGap: '1rem',
    paddingLeft: props.title && props.columnsPerRow === 1 ? '.75rem' : '0',
}));
const Title = ui_react_1.styled.div(props => ({
    marginBottom: props.titleOnly ? undefined : props.marginBottom,
    fontSize: props.fontSize,
    lineHeight: props.theme.text.lineHeight.medium,
    fontFamily: props.theme.text.headingFontFamily,
    fontWeight: 500,
    textTransform: 'capitalize',
    overflowWrap: 'anywhere',
}));
const KeyRow = ui_react_1.styled.div(props => ({
    fontSize: props.fontSize,
    lineHeight: props.theme.text.lineHeight.medium,
    fontFamily: props.theme.text.headingFontFamily,
    fontWeight: 500,
    marginBottom: '0.5rem',
}));
const ValueRow = (0, ui_react_1.styled)(ui_react_1.Row)(props => ({
    fontFamily: props.theme.text.bodyFontFamily,
    fontSize: props.fontSize,
    lineHeight: props.theme.text.lineHeight.medium,
    alignItems: 'center',
    fontWeight: 400,
    overflowWrap: 'anywhere',
}));
//# sourceMappingURL=call_detail_key_value_tile.js.map